// extracted by mini-css-extract-plugin
export var navbarSubLink = "K_hK g_hK g_hC g_cM g_dW g_f4 g_c9 g_dB";
export var menuLink = "K_wP g_hy g_gj";
export var subPageLink = "K_hP g_hP g_f8 g_gc";
export var subPageLinkColor = "K_hQ g_hQ";
export var burgerItemSmall = "K_wQ g_hN g_cL g_db";
export var Link = "K_tr x_tr x_sM x_s5";